function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* global DOMParser */

/**
 * @module ui/icon/iconview
 */
import View from '../view';
import '../../theme/components/icon/icon.css';
/**
 * The icon view class.
 *
 * @extends module:ui/view~View
 */

var IconView = /*#__PURE__*/function (_View) {
  _inherits(IconView, _View);

  var _super = _createSuper(IconView);

  /**
   * @inheritDoc
   */
  function IconView() {
    var _this;

    _classCallCheck(this, IconView);

    _this = _super.call(this);
    var bind = _this.bindTemplate;
    /**
     * The SVG source of the icon.
     *
     * @observable
     * @member {String} #content
     */

    _this.set('content', '');
    /**
     * This attribute specifies the boundaries to which the
     * icon content should stretch.
     *
     * @observable
     * @default '0 0 20 20'
     * @member {String} #viewBox
     */


    _this.set('viewBox', '0 0 20 20');
    /**
     * The fill color of the child `path.ck-icon__fill`.
     *
     * @observable
     * @default ''
     * @member {String} #fillColor
     */


    _this.set('fillColor', '');

    _this.setTemplate({
      tag: 'svg',
      ns: 'http://www.w3.org/2000/svg',
      attributes: {
        class: ['ck', 'ck-icon'],
        viewBox: bind.to('viewBox')
      }
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(IconView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(IconView.prototype), "render", this).call(this);

      this._updateXMLContent();

      this._colorFillPaths(); // This is a hack for lack of innerHTML binding.
      // See: https://github.com/ckeditor/ckeditor5-ui/issues/99.


      this.on('change:content', function () {
        _this2._updateXMLContent();

        _this2._colorFillPaths();
      });
      this.on('change:fillColor', function () {
        _this2._colorFillPaths();
      });
    }
    /**
     * Updates the {@link #element} with the value of {@link #content}.
     *
     * @private
     */

  }, {
    key: "_updateXMLContent",
    value: function _updateXMLContent() {
      if (this.content) {
        var parsed = new DOMParser().parseFromString(this.content.trim(), 'image/svg+xml');
        var svg = parsed.querySelector('svg');
        var viewBox = svg.getAttribute('viewBox');

        if (viewBox) {
          this.viewBox = viewBox;
        }

        this.element.innerHTML = '';

        while (svg.childNodes.length > 0) {
          this.element.appendChild(svg.childNodes[0]);
        }
      }
    }
    /**
     * Fills all child `path.ck-icon__fill` with the `#fillColor`.
     *
     * @private
     */

  }, {
    key: "_colorFillPaths",
    value: function _colorFillPaths() {
      var _this3 = this;

      if (this.fillColor) {
        this.element.querySelectorAll('.ck-icon__fill').forEach(function (path) {
          path.style.fill = _this3.fillColor;
        });
      }
    }
  }]);

  return IconView;
}(View);

export { IconView as default };